import { useMemo } from "react";

import { ModalWithTitle } from "@scripts/react/components/RfModal/ModalWithTitle";
import { IntegrationCodeSnippet } from "@/components/flow/shared/Deploy/IntegrationCodeSnippet";
import { generateIntegrationCMS } from "@/components/flow/shared/Deploy/documentation/generateIntegrationCMS";
import { ImageDeployment } from "@/components/flow/shared/Deploy/documentation/types";
import { useDeployContext } from "@/contexts/DeployContext";
import { Chip } from "@scripts/react/components/Chip";

interface IntegrationCodeSnippetModalProps {
    isOpen: boolean;
    onClose: () => void;
}

const ModalTitle = () => (
    <span className="flex items-center gap-2">
        Run Your Model in the Cloud
        <Chip type="text" color="gray">
            <i className="far fa-clock"></i>5 Minutes
        </Chip>
        <Chip type="text" color="gray">
            <i className="far fa-coins"></i>~1 Credit/500 Images
        </Chip>
    </span>
);

export const IntegrationCodeSnippetModal: React.FC<IntegrationCodeSnippetModalProps> = ({
    isOpen,
    onClose
}) => {
    const { workflowCredentials, workflow } = useDeployContext();

    const copy = useMemo(() => {
        const integrationCMS = generateIntegrationCMS(workflowCredentials);
        return integrationCMS.image[ImageDeployment.SINGLE];
    }, [workflowCredentials]);

    return (
        <ModalWithTitle
            isOpen={isOpen}
            onClose={onClose}
            size="xxxl"
            icon="far fa-code"
            title={<ModalTitle />}
            showFooter={false}
        >
            <div className="-mx-6 -mb-6 -mt-6 h-[75vh]">
                <IntegrationCodeSnippet
                    copy={copy}
                    blurred={!workflow}
                    isExpanded={true}
                    headerActionsOnly={true}
                />
            </div>
        </ModalWithTitle>
    );
};
